var __TEMP__ = require('./_shuffleSelf.js');var shuffleSelf = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./values.js');var values = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseShuffle;
